import { useEffect } from 'react'

function useBuyNowCleanup(productId, enabled) {
  useEffect(() => {
    if (!enabled) return

    const performCleanup = () => {
      const buyNowCartItemId = sessionStorage.getItem('buyNowCartItemId')
      const buyNowProductId = sessionStorage.getItem('buyNowProductId')

      if (!buyNowCartItemId || buyNowProductId !== String(productId)) return

      sessionStorage.removeItem('buyNowCartItemId')
      sessionStorage.removeItem('buyNowProductId')

      App.events.publish('app:cart:item:remove', {
        id: buyNowCartItemId,
        attributes: { itemId: productId, kind: 'cg' },
      })
    }

    performCleanup()

    // Edge/Safari restore pages from bfcache on back navigation, skipping React re-mount.
    // useEffect won't re-run, so we listen for pageshow to catch that case.
    const handlePageShow = (event) => {
      if (event.persisted) {
        performCleanup()
      }
    }

    window.addEventListener('pageshow', handlePageShow)
    return () => window.removeEventListener('pageshow', handlePageShow)
  }, [productId, enabled])
}

export default useBuyNowCleanup
